<template>
  <div id="app">
    <Header />
    <Sidenav v-if="!hideSideNav" />
    <div class="main" v-bind:class="{fullWidth: hideSideNav}">
      <main ref="mainContent" id="main-content" class="fill-content" tabIndex="-1">
        <router-view />
      </main>
      <som-footer light></som-footer>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Sidenav from "@/components/Sidenav";
import Header from "@/components/Header";

Vue.config.ignoredElements = [
  "som-header",
  'som-mobile-subheader',
  "som-footer",
  "som-icon",
  "som-tabs",
  "som-tab",
  "som-collapse",
  "som-footer",
  "som-modal",
  "som-alert",
  "som-date-picker",
  "som-menu",
  "som-menu-item",
  "som-button",
  "som-badge"
];

export default {
  name: "App",
  components: {
    Sidenav,
    Header
  },
  created() {
    this.hideSideNav = this.$route.meta.hideSideNav;
  },
  updated: function() {
    const blocks = document.querySelectorAll('pre code');
    for (var i = 0; i < blocks.length; i++) {
      hljs.highlightBlock(blocks[i]);
    }
  },
  watch: {
    $route(to, from) {
      this.hideSideNav = to.meta.hideSideNav;

      // Set focus to main content on route change (this is done for accessibility)
      setTimeout(() => {
        this.$refs.mainContent.focus();
      }, 0);
    }
  }
};
</script>

/* eslint-disable */
<style lang="sass?outputStyle=expanded">
@import './assets/scss/styles.scss';

.fullWidth {
  margin-left: 0;
}
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/App.vue